
import { UserManagement } from '@/core/user/user-management'
import { KTIcon } from '_metronic/helpers'
import { Content } from '_metronic/layout/components/Content'
import { Toolbar } from '_metronic/layout/components/toolbar/Toolbar'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import ProfileImageUploader from './profile-image/profile-image-uploader'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/store'
import { fileService } from '../../../projects/platform/services/file-service'
import { resetUploadState } from '@/store/upload/upload-slice'
import PermissionWrapper from '@/core/wrappers/permission-wrapper'
import { PERMISSION_CONSTANTS } from '@/core/constants/common/permission-constants'


const ProfileHeader: React.FC = () => {
  const location = useLocation()
  const dispatch = useDispatch();
  const profileImageUploaded = useSelector((state: RootState) => state.upload.profileImageUploaded);
  const [profileImage, setProfileImage] = useState<string | undefined>(undefined);
  useEffect(() => {
    (async function () {
      const result = await fileService.getProfileImageAsync();
      setProfileImage(result.data.image);
    })();
    dispatch(resetUploadState());
  }, [profileImageUploaded]);

  return (
    <>
      <Toolbar />
      <Content>
        <div className='card mb-5 mb-xl-10'>
          <div className='card-body pt-9 pb-0'>
            <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
              {profileImage !== undefined && (
                <img
                  alt="Logo"
                  width={100}
                  height={100}
                  src={
                    profileImage
                      ? `data:image/png;base64,${profileImage}`
                      : "/logo/07804c87-9a27-4b5b-9092-fadb2f043faf.png"
                  }
                  onError={(e) => {
                    if (profileImage) {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = "/logo/07804c87-9a27-4b5b-9092-fadb2f043faf.png";
                    }
                  }}
                />
              )}
              <ProfileImageUploader></ProfileImageUploader>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <a href='#' className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                        {UserManagement.getName()}  {UserManagement.getFamilyName()}
                      </a>
                      <a href='#'>
                        <KTIcon iconName='verify' className='fs-1 text-primary' />
                      </a>
                    </div>

                    <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                      <a
                        href='#'
                        className='d-flex align-items-center text-gray-500 text-hover-primary mb-2'
                      >
                        <KTIcon iconName='sms' className='fs-4 me-1' />
                        {UserManagement.getEmail()}
                      </a>
                    </div>
                  </div>

                  {/* <div className='d-flex my-4'>
                    <a href='#' className='btn btn-sm btn-light me-2' id='kt_user_follow_button'>
                      <KTIcon iconName='check' className='fs-3 d-none' />

                      <span className='indicator-label'>Follow</span>
                      <span className='indicator-progress'>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    </a>
                    <a
                      href='#'
                      className='btn btn-sm btn-primary me-3'
                      data-bs-toggle='modal'
                      data-bs-target='#kt_modal_offer_a_deal'
                    >
                      Hire Me
                    </a>
                    <div className='me-0'>
                      <button
                        className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='top-end'
                      >
                        <i className='bi bi-three-dots fs-3'></i>
                      </button>
                      <Dropdown1 />
                    </div>
                  </div> */}
                </div>

                {/* <div className='d-flex flex-wrap flex-stack'>
                  <div className='d-flex flex-column flex-grow-1 pe-8'>
                    <div className='d-flex flex-wrap'>
                      <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                        <div className='d-flex align-items-center'>
                          <KTIcon iconName='arrow-up' className='fs-3 text-success me-2' />
                          <div className='fs-2 fw-bolder'>4500$</div>
                        </div>

                        <div className='fw-bold fs-6 text-gray-500'>Earnings</div>
                      </div>

                      <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                        <div className='d-flex align-items-center'>
                          <KTIcon iconName='arrow-down' className='fs-3 text-danger me-2' />
                          <div className='fs-2 fw-bolder'>75</div>
                        </div>

                        <div className='fw-bold fs-6 text-gray-500'>Projects</div>
                      </div>

                      <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                        <div className='d-flex align-items-center'>
                          <KTIcon iconName='arrow-up' className='fs-3 text-success me-2' />
                          <div className='fs-2 fw-bolder'>60%</div>
                        </div>

                        <div className='fw-bold fs-6 text-gray-500'>Success Rate</div>
                      </div>
                    </div>
                  </div>

                  <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                    <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                      <span className='fw-bold fs-6 text-gray-500'>Profile Compleation</span>
                      <span className='fw-bolder fs-6'>50%</span>
                    </div>
                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                      <div
                        className='bg-success rounded h-5px'
                        role='progressbar'
                        style={{ width: '50%' }}
                      ></div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            <div className='d-flex overflow-auto h-55px'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                <li className='nav-item'>
                  <Link
                    className={
                      `nav-link text-active-primary me-6 ` +
                      (location.pathname === '/profile/profile-informations' && 'active')
                    }
                    to='/profile/profile-informations'
                  >
                    {t('profile_informations')}
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link
                    className={
                      `nav-link text-active-primary me-6 ` +
                      (location.pathname === '/profile/new-credential' && 'active')
                    }
                    to='/profile/new-credential'
                  >
                    {t('new_credential')}
                  </Link>
                </li>
                <PermissionWrapper permission={PERMISSION_CONSTANTS.CONNECTED_APP} action="Create">
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/profile/connect-app' && 'active')
                      }
                      to='/profile/connect-app'
                    >
                      {t('connect_app')}
                    </Link>
                  </li>
                </PermissionWrapper>
                <PermissionWrapper permission={PERMISSION_CONSTANTS.CONNECTED_APP} action="Create">
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/profile/connected-apps' && 'active')
                      }
                      to='/profile/connected-apps'
                    >
                      {t('connected_apps')}
                    </Link>
                  </li>
                </PermissionWrapper>
              </ul>
            </div>
          </div>
        </div>
      </Content>
    </>
  )
}

export { ProfileHeader }
